/* eslint-disable max-len */
import * as React from 'react';

const Download = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7795 2.97206C12.0499 2.7017 12.4882 2.7017 12.7586 2.97206L17.374 7.58744C17.6443 7.85781 17.6443 8.29615 17.374 8.56651C17.1036 8.83688 16.6653 8.83688 16.3949 8.56651L12.9614 5.13297V14.5385C12.9614 14.9209 12.6514 15.2308 12.269 15.2308C11.8867 15.2308 11.5767 14.9209 11.5767 14.5385V5.13297L8.14319 8.56651C7.87283 8.83688 7.43449 8.83688 7.16412 8.56651C6.89376 8.29615 6.89376 7.85781 7.16412 7.58744L11.7795 2.97206ZM3.96135 13.8462C4.3437 13.8462 4.65366 14.1562 4.65366 14.5385V18.2308C4.65366 18.5368 4.77522 18.8303 4.99161 19.0467C5.208 19.2631 5.50149 19.3847 5.8075 19.3847H18.7306C19.0366 19.3847 19.3301 19.2631 19.5465 19.0467C19.7629 18.8303 19.8844 18.5368 19.8844 18.2308V14.5385C19.8844 14.1562 20.1944 13.8462 20.5767 13.8462C20.9591 13.8462 21.269 14.1562 21.269 14.5385V18.2308C21.269 18.9041 21.0016 19.5497 20.5255 20.0258C20.0495 20.5018 19.4038 20.7693 18.7306 20.7693H5.8075C5.13426 20.7693 4.48859 20.5018 4.01254 20.0258C3.53649 19.5497 3.26904 18.9041 3.26904 18.2308V14.5385C3.26904 14.1562 3.579 13.8462 3.96135 13.8462Z"
      fill="#D1D1D1"
    />
  </svg>
);
export default Download;
